import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { createApi as createApi2, fetchBaseQuery as fetchBaseQuery2 } from '@reduxjs/toolkit/query/react'

const env = process.env.NODE_ENV;

const baseURL= (env === 'production') ? 'https://lnb.ai/api/v1' : 'http://localhost:3001'

export const ReportsApi = createApi({
  reducerPath: 'ReportsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState()).auth.profile.token
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    getApiHealth: builder.query({
      query: () => 'health',
    }),
    getCompany: builder.query({
      query: (companyId) => `companies/${companyId}`
    }),
    getEmployeeAttendanceDetails: builder.query({
      query: ({companyId, employeeProfileDataId, startDate}) => {
        return {
          url: `companies/${companyId}/employees/${employeeProfileDataId}/attendance_details`,
          params: {start_date: startDate},
        }
      }
    }),
    getEmployeeTimes: builder.query({
      query: ({
        companyId,
        companyNameText,
        endDate,
        projectIds,
        startDate,
      }) => {
        return {
          url: `reports/employees/employee_times`,
          params: {
            company_id: companyId,
            company_name_search: companyNameText,
            end_date: endDate,
            project_ids: projectIds,
            start_date: startDate,
          }
        }
      },
    }),
    getExcelDownload: builder.query({
      query: () => 'excel_download',
    }),
    getLivePlantDashboard: builder.query({
      query: ({projectId}) => {
        return {
          url: `/projects/${projectId}/live_plant_dashboard`,
        }
      }
    }),
    getPlanComments: builder.query({
      query: ({projectIds, startDate, endDate}) => {
        return {
          url: `plan_comments`,
          params: {project_ids: projectIds, start_date: startDate, end_date: endDate},
        }
      }
    }),
    getPlantDeliveries: builder.query({
      query: ({companyId, startDate, endDate}) => {
        return {
          url: `companies/${companyId}/project_plant_deliveries`,
          params: {start_date: startDate, end_date: endDate},
        }
      }
    }),
    getPlantActivityAnalysis: builder.query({
      query: ({projectId, startDate, endDate}) => {
        return {
          url: `projects/${projectId}/plant_activity_analysis`,
          params: {start_date: startDate, end_date: endDate},
        }
      }
    }),
    getProjectCompany: builder.query({
      query: (projectId) => `projects/${projectId}/company`
    }),
    getProjectCompletionRequirements: builder.query({
      query: (projectId) => `projects/${projectId}/completion_requirements`,
    }),
    getProjectDashboard: builder.query({
      query: ({companyId, projectId, startDate}) => {
        return {
          url: `reports/companies/${companyId}/projects/${projectId}`,
          params: {start_date: startDate},
        }
      }
    }),
    getFirstLastPlantAnalysis: builder.query({
      query: ({projectId, startDate, endDate}) => {
        return {
          url: `projects/${projectId}/plant_first_last_analysis`,
          params: {start_date: startDate, end_date: endDate},
        }
      }
    }),
    getProjectDelayReasons: builder.query({
      query: (projectId) => `projects/${projectId}/delay_reasons`,
    }),
    getProjectMaterials: builder.query({
      query: (projectId) => `projects/${projectId}/materials`,
    }),
    getProjectLocations: builder.query({
      query: (projectId) => `projects/${projectId}/locations`,
    }),
    getProjects: builder.query({
      query: ({companyId, startDate, endDate}) => {
        return {
          url: `companies/${companyId}/projects`,
          params: {start_date: startDate, end_date: endDate},
        }
      }
    }),
    getSimSummary: builder.query({
      query: (projectIds) => {
        return {
          url: `sim_cards`,
          params: {project_ids: projectIds},
        }
      }
    }),
    getCraneDashboard: builder.query({
      query: ({startDate, endDate}) => {
        return {
          url: `reports/crane_dashboard`,
          params: {start_date: startDate, end_date: endDate},
        }
      }
    }),
    postLogin: builder.mutation({
      query: (body) => ({
        url: 'login',
        method: 'POST',
        body: body,
      }),
    }),
  }),
})

export const { 
  useGetCompanyQuery,
  useGetCraneDashboardQuery,
  useGetEmployeeTimesQuery,
  useGetLivePlantDashboardQuery,
  useGetPlantActivityAnalysisQuery,
  useGetFirstLastPlantAnalysisQuery,
  useGetProjectDashboardQuery,
  useGetProjectDelayReasonsQuery,
  useGetProjectLocationsQuery,
  useGetProjectMaterialsQuery,
  useGetProjectsQuery,
  usePostLoginMutation,
} = ReportsApi

// Engagement Dashboard API

const env2 = process.env.NODE_ENV;
const baseURL2 = (env2 === 'production') ? 'https://lnb.ai/api/v1' : 'http://localhost:3001'

export const EngagementApi = createApi2({
  reducerPath: 'EngagementApi',
  baseQuery: fetchBaseQuery2({
    baseUrl: baseURL2,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState()).auth.profile.token
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    getEngagementDashboard: builder.query({
      query: ({companyId, startDate, endDate}) => {
        return {
          url: `reports/companies/${companyId}/engagement_dashboard`,
          params: {start_date: startDate, end_date: endDate},
        }
      }
    }),
  }),
})

export const { useGetEngagementDashboardQuery } = EngagementApi
